module.exports = __webpack_public_path__ + "img/How-Tech-Works-Graphic.076a89b9.png";